<template>
  <v-card id="cage_seltr">
    <v-card-title>
      <span class='tit'>已选择的仓储笼[{{this.cages.length}}]:</span>
    </v-card-title>
    <v-card-text>
      <div>{{ message }}</div>
      <v-chip
        v-for="cage in cages"
        :key = "cage.cage_no"
        close
        :color="clrCage(cage)"
        text-color="white"
        style="font-size:14px;font-weight: bold;"
        @click:close="rmCageNo(cage.cage_no)"
        >
        {{ cage.cage_no }}
      </v-chip>
    </v-card-text>
    <v-card-actions>
      <v-btn :disabled="!canSend" @click="SendCage()">立即发出</v-btn>
      <v-btn :disabled="!canReturn" @click="ReturnCage()">立即收回</v-btn>
    </v-card-actions>
  </v-card>
</template>

<style>
#cage_seltr {
  margin-top: 10px;
  background-color: #eee;
  min-height: 30px;
}
.tit {
  font-size: 16px;
  font-weight: bold;
}
</style>

<script>
import { sendCage, returnCage } from '@/api/cage';
import { Msg, MsgError } from '@/libs/util';

export default {
  name: 'CageSeltr',
  data () {
    return {
      message: '',
      cages: []
    }
  },
  watch: {},
  computed: {
    canSend () {
      for (var i = 0; i < this.cages.length; ++i) {
        if (this.cages[i].a_out === 0) {
          return true
        }
      }
      return false
    },
    canReturn () {
      for (var i = 0; i < this.cages.length; ++i) {
        if (this.cages[i].a_out > 0) {
          return true
        }
      }
      return false
    }
  },
  methods: {
    setMsg (msg) {
      this.message = msg
    },
    getCages () {
      var cgs = []
      this.cages.forEach(e => {
        cgs.push(e.cage_no)
      })
      return cgs
    },
    SendCage () {
      if (this.canReturn) {
        MsgError('有已发出的，不能立即发出');
        return
      }
      sendCage(this.getCages()).then(res => {
        var s = '立即发出成功! ' + res.msg
        Msg(s)
        this.cages = []
        this.setMsg(res.msg)
        this.$emit('doOk')
      })
    },
    ReturnCage () {
      if (this.canSend) {
        MsgError('有未发出的，不能立即收回')
        return
      }
      returnCage(this.getCages()).then(res => {
        Msg('立即收回成功')
        this.cages = []
        this.setMsg(res.msg)
        this.$emit('doOk')
      })
    },
    clrCage (cage) {
      if (cage.a_out === 0) {
        return 'green'
      }
      return 'red'
    },
    sortA (a, b) {
      return a.cage_no - b.cage_no
    },
    sort () {
      this.cages.sort(this.sortA)
    },
    Add (item) {
      this.cages.push(item)
      this.sort()
    },
    rmCage (cage) {
      this.cages.splice(this.cages.indexOf(cage), 1)
      this.sort()
    },
    inCages (no) {
      for (var i = 0; i < this.cages.length; ++i) {
        if (this.cages[i].cage_no === no) {
          return true
        }
      }
      return false
    },
    rmCageNo (no) {
      for (var i = 0; i < this.cages.length; ++i) {
        if (this.cages[i].cage_no === no) {
          this.cages.splice(i, 1)
          this.sort()
          this.$emit('rmCage', no)
          return
        }
      }
    }
  },
  mounted () {}
}
</script>
